import { ClerkComponentsFeature } from '@components/common/clerk-components';
import React from 'react';

const feature = {
  featureTitle: 'Customizable to your business',
  featureDesc:
    'Styling is just the start – we understand that every business has unique needs for their sign-up flow and can accommodate most requests out-of-the-box.',
  bottomCta: {
    description: 'Looking for something you don’t see here?',
    cta: 'Contact us',
    internalHref: '/support',
    icon: 'ArrowSmRightIcon'
  },
  items: [
    {
      itemTitle: 'Your choice of authentication strategies',
      itemDesc:
        'Different businesses needs users to sign in different ways – choose only the ones that are right for your application.',
      icon: 'ShieldCheckIcon'
    },
    {
      itemTitle: 'Match your brand',
      itemDesc:
        'Add your logo and choose your font, colors, and other styles to match your brand.',
      icon: 'ColorSwatchIcon'
    },
    {
      itemTitle: 'Integrate your way',
      itemDesc:
        'Embed the component in your page, overlay it in a modal, or forward users to the Clerk-hosted User Management Portal.',
      icon: 'PuzzleIcon'
    }
  ]
};

type TProps = {
  className?: string;
  imagePosition?: 'left' | 'right';
};

export const Customizable: React.FC<TProps> = props => {
  const { className } = props;
  let { imagePosition } = props;
  if (!imagePosition) {
    imagePosition = 'right';
  }

  return (
    <section className={className}>
      <div className="mx-auto flex max-w-7xl flex-col px-6 py-16 lg:py-24">
        <ClerkComponentsFeature
          key={feature.featureTitle}
          imageFileURL="/images/customizable.svg"
          imagePosition={imagePosition}
          {...feature}
        />
      </div>
    </section>
  );
};
